import React from "react";
import { ClubLogo } from "../primitives";
import Confetti from "../Confetti";
import JoinButton from "./JoinButton";

/**
 * Explore Clubs card (mockup `.clubcard`). The card itself is not interactive: a real <button> (.cl-open)
 * is stretched over it to open the club, and the join control sits above it (no nested interactive).
 */
export default function ClubCard({ club, state, busy, burst = 0, onOpen, onJoin }) {
  const n = club.member_count || 0;
  return (
    <div className="card clubcard">
      {burst > 0 && <Confetti fire={burst} />}
      <button type="button" className="cl-open" onClick={() => onOpen(club)} data-testid={`home.row.${club.id}`} aria-label={`Open ${club.name || "club"}`} />
      <ClubLogo club={club} size={54} />
      <div className="grow" style={{ minWidth: 0 }}>
        <h3 className="cl-name" title={club.name}>{club.name}</h3>
        <div className="meta">{[club.category, `${n} member${n === 1 ? "" : "s"}`].filter(Boolean).join(" · ")}</div>
        {club.description ? <p>{club.description}</p> : null}
      </div>
      <div className="cl-join">
        <JoinButton state={state} busy={busy} onPress={() => onJoin(club, state)} testId={`home.row.${club.id}.join`} />
      </div>
    </div>
  );
}
